import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../lib/api';
import StatusBadge from '../components/StatusBadge';
import { Palette } from 'lucide-react';

export default function ColorMatch() {
  const [sales, setSales] = useState([]);

  const load = () => {
    api.get('/sales').then(all => {
      setSales(all.filter(s => s.color_match_needed && s.status !== 'cancelled'));
    });
  };
  useEffect(load, []);

  const updateStatus = async (id, status) => {
    await api.put(`/sales/${id}`, { color_match_status: status });
    load();
  };

  const statuses = ['pending', 'sent', 'received', 'unavailable'];

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6 flex items-center gap-2"><Palette className="w-6 h-6" /> Color Match Queue</h1>

      <div className="bg-white rounded-xl border overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-left font-medium text-gray-500">Customer</th>
              <th className="px-4 py-3 text-left font-medium text-gray-500">Color</th>
              <th className="px-4 py-3 text-left font-medium text-gray-500">Footage</th>
              <th className="px-4 py-3 text-left font-medium text-gray-500">Match Status</th>
              <th className="px-4 py-3 text-left font-medium text-gray-500">Sale Status</th>
              <th className="px-4 py-3 text-left font-medium text-gray-500">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y">
            {sales.map(s => (
              <tr key={s.id} className="hover:bg-gray-50">
                <td className="px-4 py-3">
                  <Link to={`/sales/${s.id}`} className="text-nova-600 hover:underline font-medium">{s.customer_name}</Link>
                  <p className="text-xs text-gray-400">{s.city}</p>
                </td>
                <td className="px-4 py-3">{s.color_name || 'TBD'}</td>
                <td className="px-4 py-3">{s.total_footage}ft</td>
                <td className="px-4 py-3"><StatusBadge status={s.color_match_status} /></td>
                <td className="px-4 py-3"><StatusBadge status={s.status} /></td>
                <td className="px-4 py-3">
                  <div className="flex gap-1 flex-wrap">
                    {statuses.filter(st => st !== s.color_match_status).map(st => (
                      <button key={st} onClick={() => updateStatus(s.id, st)}
                        className="px-2 py-1 text-xs border rounded hover:bg-gray-100 capitalize">
                        {st}
                      </button>
                    ))}
                  </div>
                </td>
              </tr>
            ))}
            {sales.length === 0 && (
              <tr><td colSpan={6} className="px-4 py-8 text-center text-gray-400">No color match requests</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
